var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_1494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15297 10.7581C2.12262 9.72773 1.60744 9.21255 1.41574 8.54415C1.22405 7.87574 1.38787 7.16583 1.71553 5.746L1.90448 4.92721C2.18013 3.7327 2.31796 3.13544 2.72695 2.72646C3.13593 2.31747 3.73319 2.17965 4.9277 1.90399L5.74649 1.71504C7.16631 1.38739 7.87623 1.22356 8.54463 1.41526C9.21304 1.60695 9.72822 2.12213 10.7586 3.15249L11.9783 4.37224C13.771 6.1649 14.6673 7.06123 14.6673 8.17504C14.6673 9.28886 13.771 10.1852 11.9783 11.9778C10.1857 13.7705 9.28935 14.6668 8.17553 14.6668C7.06172 14.6668 6.16539 13.7705 4.37273 11.9778L3.15297 10.7581Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.73718,
    cy: 5.91943,
    r: 1.33333,
    transform: "rotate(-45 5.73718 5.91943)",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69548 12.333L12.3481 7.68018",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_1494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.b0b4057c75863c276100bf363dfee4f7.svg";
export { ForwardRef as ReactComponent };